import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import CheckIcon from "@mui/icons-material/Check";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const checkTimeout = 4000;

const ShareUrl = ({ url }) => {
  const [copied, setCopied] = useState(false);
  const [state, setState] = useState("initial"); // initial, loading, success, error

  const stateToIcon = {
    initial: <ContentPasteIcon />,
    loading: <CircularProgress size="24px" />,
    success: <CheckIcon />,
    error: <CloseIcon />,
  };

  const onClick = (e) => {
    e.preventDefault();
    setState("loading");
    // fetch the url
    fetch(url)
      .then((response) => {
        if (response.ok) {
          setState("success");
          navigator.clipboard.writeText(url);
        } else {
          setState("error");
        }
      })
      .catch(() => {
        setState("error");
      })
      .finally(() => {
        setTimeout(() => {
          setState("initial");
        }, checkTimeout);
      });
  };
  return (
    <div
      style={{
        outline: "solid 2.5px black",
        display: "flex",
        flexDirection: "row",
        backgroundColor: "rgba(0,0,0,0.4)",
        gap: "0px",
        color: "var(--text-color)",
        margin: "5px",
        borderRadius: "5px",
      }}
    >
      <div
        style={{
          borderRight: "solid 2px black",
          display: "flex",
          padding: "5px 10px",
          justifyContent: "center",
          alignItems: "center",
          wordBreak: "break-all",
        }}
      >
        {url}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "5px 10px",
          alignItems: "center",
          maxWidth: "50px",
          cursor: "pointer",
        }}
      >
        <a
          href={url}
          style={{
            color: copied ? "green" : "var(--text-color)",
            lineHeight: "1",
          }}
          onClick={onClick}
        >
          {stateToIcon[state]}
        </a>
      </div>
    </div>
  );
};

export default ShareUrl;
